
export class SimpleButton extends createjs.MovieClip {
	// public enabled: boolean;
	protected clickDownListener: Function;
	protected mouseDownListener: Function;
	protected mouseUpListener: Function;
	protected mouseOverListener: Function;
	protected mouseOutListener: Function;
	protected clickFunc: Function;
	protected clickParam: object;
	protected mouseDownFunc: Function;
	protected mouseDownParam: object;
	protected mouseUpFunc: Function;
	protected mouseUpParam: object;
	protected mouseOverFunc: Function;
	protected mouseOverParam: object;
	protected mouseOutFunc: Function;
	protected mouseOutParam: object;
	protected hitTestState: createjs.Shape;
	private _bEnable: boolean = false;
	get bEnable() {
		return this._bEnable;
	}

	constructor(upState?: createjs.DisplayObject, overState?: createjs.DisplayObject, downState?: createjs.DisplayObject, disableState?: createjs.DisplayObject, hitTestState?: createjs.DisplayObject) {
		super();
		if (upState) {
			this.init(upState, overState, downState, disableState, hitTestState)
		}
	}

	init(upState: createjs.DisplayObject, overState?: createjs.DisplayObject, downState?: createjs.DisplayObject, disableState?: createjs.DisplayObject, hitTestState?: createjs.DisplayObject) {
		this.hitArea = (hitTestState) ? hitTestState : upState;
		const upTween = new createjs.Tween(upState).set({ visible: true }).wait(1).set({ visible: false });
		this.timeline.addLabel('up', 0);
		this.timeline.addTween(upTween);

		if (overState) {
			const overTween = new createjs.Tween(overState).set({ visible: false }).wait(1).set({ visible: true }).wait(1).set({ visible: false });
			this.timeline.addLabel('over', 1);
			this.timeline.addTween(overTween);
		}

		if (downState) {
			const downTween = new createjs.Tween(downState).set({ visible: false }).wait(2).set({ visible: true }).wait(1).set({ visible: false });
			this.timeline.addLabel('down', 2);
			this.timeline.addTween(downTween);
		}

		if (disableState) {
			const disableTween = new createjs.Tween(disableState).set({ visible: false }).wait(3).set({ visible: true });
			this.timeline.addLabel('disable', 3);
			this.timeline.addTween(disableTween);
		}

		if (hitTestState) {
			this.hitArea = hitTestState
		}

		this.enable()
	}

	mouseUp = () => {
		this.gotoAndStop('up');
		if (this.mouseUpFunc) {
			if (this.mouseUpParam) {
				this.mouseUpFunc(this.mouseUpParam);
			} else {
				this.mouseUpFunc();
			}
		}
	}

	mouseDown = () => {
		// evt.remove();
		this.gotoAndStop('down');
		if (this.mouseDownFunc) {
			if (this.mouseDownParam) {
				this.mouseDownFunc(this.mouseDownParam);
			} else {
				this.mouseDownFunc();
			}
		}
	}

	click = () => {
		this.gotoAndStop('down');
		if (this.clickFunc) {
			if (this.clickParam) {
				this.clickFunc(this.clickParam);
			} else {
				this.clickFunc();
			}
		}
	}

	mouseOver = () => {
		document.body.style.cursor = "pointer";
		this.gotoAndStop('over');
		if (this.mouseOverFunc) {
			if (this.mouseOverParam) {
				this.mouseOverFunc(this.mouseOverParam);
			} else {
				this.mouseOverFunc();
			}
		}
	}
	mouseOverCursor = () => {
		document.body.style.cursor = "pointer";
	}

	mouseOut = () => {
		document.body.style.cursor = "";
		this.gotoAndStop('up');
		if (this.mouseOutFunc) {
			if (this.mouseOutParam) {
				this.mouseOutFunc(this.mouseOutParam);
			} else {
				this.mouseOutFunc();
			}
		}
	}
	mouseOutCursor = () => {
		document.body.style.cursor = "";
	}

	setEnabled(b: boolean): void {
		if (!b) {
			this.disable();
		} else {
			this.enable();
		}
	}

	removeMouseEventListeners() {
		this.off('click', this.click);
		this.off('mousedown', this.mouseDown);
		this.off('pressup', this.mouseUp);
		this.off('mouseover', this.mouseOver);
		this.off('mouseover', this.mouseOverCursor);
		this.off('mouseout', this.mouseOut);
		this.off('mouseout', this.mouseOutCursor);
	}

	enable() {
		this._bEnable = true;
		this.removeMouseEventListeners();
		this.addEventListener('click', this.click);
		this.addEventListener('mousedown', this.mouseDown);
		this.addEventListener('pressup', this.mouseUp);
		this.addEventListener('mouseover', this.mouseOver);
		this.addEventListener('mouseout', this.mouseOut);
		this.gotoAndStop('up');
	}

	keepDown() {
		this._bEnable = true;
		this.removeMouseEventListeners();
		this.addEventListener('click', this.click);
		this.addEventListener('mousedown', this.mouseDown);
		// this.addEventListener('pressup', this.mouseUp);
		this.addEventListener('mouseover', this.mouseOverCursor);
		this.addEventListener('mouseout', this.mouseOutCursor);
		this.gotoAndStop('down');
	}

	disable() {
		this._bEnable = false;
		this.removeMouseEventListeners();
		this.gotoAndStop('disable');
	}

	setFunc(type: string, callBack: Function, param?: object) {
		switch (type) {
			case 'mousedown':
				this.mouseDownFunc = callBack;
				if (param) this.mouseDownParam = param;
				break;
			case 'mouseup':
				this.mouseUpFunc = callBack;
				if (param) this.mouseUpParam = param;
				break;
			case 'click':
				this.clickFunc = callBack;
				if (param) this.clickParam = param;
				break;
			case 'mouseover':
				this.mouseOverFunc = callBack;
				if (param) this.mouseOverParam = param;
				break;
			case 'mouseout':
				this.mouseOutFunc = callBack;
				if (param) this.mouseOutParam = param;
			default:
				break
		}
	}

	static makeOverState(upState: createjs.DisplayObject) {
		const bounds = upState.getBounds();
		upState.filters = [
			new createjs.ColorFilter(1, 1, 1, 1, 30, 30, 30, 0)
		];
		upState.cache(bounds.x, bounds.y, bounds.width, bounds.height);
		return upState;
	}

	static makeDisableState(upState: createjs.DisplayObject) {
		const bounds = upState.getBounds();
		upState.filters = [
			new createjs.ColorFilter(1, 1, 1, 1, -90, -90, -90, 0)
		];
		upState.cache(bounds.x, bounds.y, bounds.width, bounds.height);
		return upState;
	}
}